import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomResultOfSuperAdminAuditVm } from 'src/app/core/api/models';
import { SuperAdminsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from '../../shared/base/components/base-index-page.component';
import { SuperAdminAuditDto } from './../../../core/api/models/super-admin-audit-dto';
import { SuperAdminAuditVm } from './../../../core/api/models/super-admin-audit-vm';
import { PageNames } from 'src/app/configs/page-names.enum';
import { BaseIndexModule } from '../../shared/base/modules/base-index.module';
import { SuperAdminAuditsDetailsComponent } from "./super-admin-audits-details/super-admin-audits-details.component";
import { TextPopoverDirective } from 'src/app/core/directives/text-popover.directive';


@Component({
    selector: 'app-super-admin-audits',
    templateUrl: './super-admin-audits.component.html',
    imports: [BaseIndexModule,
        SuperAdminAuditsDetailsComponent,
        TextPopoverDirective]
})
export class SuperAdminAuditsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = PageNames.superAdminAudits;
  modelWithPagination$: Observable<SuperAdminAuditVm>;
  items$: Observable<Array<SuperAdminAuditDto>>;

  protected currentService = inject(SuperAdminsService);
  paginationApiMethodName: string = this.currentService.superAdminsGetSuperAdminAuditsWithPagination.name;

  //details
  showDetails: boolean = false;
  detailModel: SuperAdminAuditDto;

  //#endregion

  constructor() {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = false;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.tableConfig.pageSizes = [30, 40, 50, 60, 80, 100];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: this.localizer.userName,
        name: 'Document.UserInfo.userName',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}environment.culture`,
        name: 'Document.Environment.Culture',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}logLocation`,
        name: 'Document.LogLocation',
        hasSearch: true,
        noSorting: true,
        type: 'enumValue',
        enumName: 'SuperAdminLogLocation',
      },
      {
        title: `${this.tableVocabs}logText`,
        name: 'Document.LogText',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}startDate`,
        name: 'Document.StartDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: `${this.tableVocabs}endDate`,
        name: 'Document.EndDate',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      this.sortObject.push({ columnName: 'Document.StartDate', sort: 1 });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  onDetail(model: SuperAdminAuditDto, setFiltersAndUrl = true) {
    // this.showParent = false;
    // this.setParentQueryString();
    // if (setFiltersAndUrl) {
    //   this.location.go(
    //     window.location.pathname +
    //       '?' +
    //       QueryStringTypesEnum.Details_key +
    //       '=' +
    //       JSON.stringify(model)
    //   );
    // }
    this.showDetails = true;
    this.detailModel = model;
  }

  onCloseDetail(event) {
    this.showDetails = false;
  }
}
